import Base from '#BASE/store/userInfo/userInfo.store';
import { getterTypes, mutationTypes, actionTypes } from 'BASE/store/types';
import { storage } from 'BASE/common/util/util.storage';
import constant from 'BASE/common/lotteryConstant';
export const dailyPayType = constant.DailyPayType;

export default class extends Base {
    constructor() {
        super();
        this.state.privileges.dailyPayCGCreationAllowed = undefined;
        this.state.privileges.externalGameDailyPayCreationAllowed = undefined;
        this.actions[actionTypes.USER_INFO_PRIVILEGES_BONUS] = async (context, payload) => {
            context.commit(mutationTypes.USER_INFO_PRIVILEGES_BONUS, {
                contractCreationAllowed: undefined,
                dailyPayCreationAllowed: undefined,
                haveContract: undefined,
                haveDailyPay: undefined,
                dailyPayCGCreationAllowed: undefined,
                haveCGDailyPay: undefined,
                haveExternalGameDailyPay: undefined,
                dailyPayPermission: [],
                externalGameDailyPayCreationAllowed: undefined,
                haveBonusWallet: undefined
            });
            if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
                try {
                    let _result = await $.post('/api/BonusPrivileges/Get');
                    let dailyPayCreationAllowed =  _result.dailyPayPermission.find(e => e === dailyPayType.BET_PAY) ? true : false;
                    let externalGameDailyPayCreationAllowed = _result.dailyPayPermission.find(e => e === dailyPayType.VIDEO_SLOT) ? true : false;
                    let dailyPayCGCreationAllowed = _result.dailyPayPermission.find(e => e === dailyPayType.CG_PAY) ? true : false;
                    context.commit(mutationTypes.USER_INFO_PRIVILEGES_BONUS, {
                        contractCreationAllowed: _result.contractCreationAllowed,
                        dailyPayCreationAllowed: dailyPayCreationAllowed,
                        haveContract: _result.haveContract,
                        haveDailyPay: _result.haveDailyPay,
                        haveCGDailyPay: _result.haveCGDailyPay,
                        haveExternalGameDailyPay: _result.haveExternalGameDailyPay,
                        dailyPayPermission: _result.dailyPayPermission,
                        dailyPayCGCreationAllowed: dailyPayCGCreationAllowed,
                        externalGameDailyPayCreationAllowed: externalGameDailyPayCreationAllowed,
                        haveBonusWallet: _result.haveBonusWallet
                    });
                }
                catch (err) {
                    console.error(err);
                }
            }
        };
        this.mutations[mutationTypes.USER_INFO_PRIVILEGES_BONUS] = (state, payload) => {
            state.privileges.contractCreationAllowed = payload.contractCreationAllowed;
            state.privileges.dailyPayCreationAllowed = payload.dailyPayCreationAllowed;
            state.privileges.haveContract = payload.haveContract;
            state.privileges.haveDailyPay = payload.haveDailyPay;
            state.privileges.haveCGDailyPay = payload.haveCGDailyPay;
            state.privileges.haveExternalGameDailyPay = payload.haveExternalGameDailyPay;
            state.privileges.dailyPayPermission = payload.dailyPayPermission;
            state.privileges.dailyPayCGCreationAllowed = payload.dailyPayCGCreationAllowed;
            state.privileges.externalGameDailyPayCreationAllowed = payload.externalGameDailyPayCreationAllowed;
            state.privileges.haveBonusWallet = payload.haveBonusWallet;
        };
    }
}